/**
 * Resolve in-app navigation path for a notification based on metadata and user role.
 */
export function getNotificationNavigationPath(notification, user) {
  if (!notification) return null;

  const role = String(user?.role?.slug || user?.role || "admin").toLowerCase();
  const rolePath = role === "institute" ? "admin" : role;
  const entityType = notification.metadata?.entityType || notification.type;

  switch (entityType) {
    case "leave": {
      if (notification.metadata?.status) {
        return role === "student" ? "/student/leaves" : "/apply-leave";
      }
      if (notification.metadata?.applicantName) {
        return `/${rolePath}/leaves`;
      }
      return role === "student" ? "/student/leaves" : "/apply-leave";
    }
    case "assignment":
      return role === "student" ? "/student/assignments" : `/${rolePath}/assignments`;
    case "material":
      return role === "student" ? "/student/materials" : `/${rolePath}/materials`;
    case "exam":
      return role === "student" ? "/student/exam-results" : `/${rolePath}/exam-management`;
    case "fee_assignment":
    case "fee_payment":
    case "fee_receipt":
    case "fee":
      if (role === "student") return "/student/fees";
      return `/${rolePath}/fees/reports`;
    case "schedule_change":
    case "scheduleChangeRequest":
    case "schedule_change_outcome":
      if (role === "institute") return `/${rolePath}/timetable`;
      return `/${rolePath}/schedule-change`;
    case "editProfileRequest":
      return `/${rolePath}/requests`;
    case "device_approval":
      return `/${rolePath}/requests/device-logins`;
    default:
      if (notification.type === "device_approval") {
        return `/${rolePath}/requests/device-logins`;
      }
      if (notification.type === "fee") {
        if (role === "student") return "/student/fees";
        return `/${rolePath}/fees/reports`;
      }
      return null;
  }
}
